import { useCallback, useRef, useEffect } from 'react';

const useDebounce = (callback, delay) => {
  const timeoutRef = useRef();
  const savedCallback = useRef(callback);

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const debouncedCallback = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      savedCallback.current(...args);
    }, delay);
  }, [delay]);

  return debouncedCallback;
};

export default useDebounce;
